













import Vue from "vue";
import Component from "vue-class-component";
import BottomNav from "@/components/BottomNav.vue";
import CycleSelector from "@/components/CycleSelector.vue";
	@Component({
		components: { BottomNav, CycleSelector }
	})
export default class App extends Vue {
  isShowSidebar = true;
  addProjectDialogVisible = false; 
}
